import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MainLayout } from './components/layout/MainLayout';
import { HomePage } from './pages/HomePage';
import { AliExpressProductsPage } from './pages/AliExpressProductsPage';
import { AliExpressProductDetailPage } from './pages/AliExpressProductDetailPage';
import { AliExpressCategoriesPage } from './pages/AliExpressCategoriesPage';
import { AliExpressCategoryPage } from './pages/AliExpressCategoryPage';
import { MonthlyPicksPage } from './pages/MonthlyPicksPage';
import { ComparisonPage } from './pages/ComparisonPage';
import { RecommendationsPage } from './pages/RecommendationsPage';
import { GuidesPage } from './pages/GuidesPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 30, // 30 minutes (increased from 5 min)
      gcTime: 1000 * 60 * 60, // 1 hour (renamed from cacheTime in v5)
      retry: 1,
      refetchOnWindowFocus: false, // Disable refetch on window focus
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />

            {/* Products - AliExpress */}
            <Route path="products" element={<AliExpressProductsPage />} />
            <Route path="products/aliexpress/:id" element={<AliExpressProductDetailPage />} />

            {/* Categories - AliExpress */}
            <Route path="categories" element={<AliExpressCategoriesPage />} />
            <Route path="categories/:slug" element={<AliExpressCategoryPage />} />

            {/* Recommendations */}
            <Route path="recommendations" element={<RecommendationsPage />} />

            {/* Monthly Picks */}
            <Route path="monthly-picks" element={<MonthlyPicksPage />} />
            <Route path="monthly-picks/:category" element={<MonthlyPicksPage />} />

            {/* Comparison */}
            <Route path="compare" element={<ComparisonPage />} />

            {/* Blog/Guides */}
            <Route path="guides" element={<GuidesPage />} />

            {/* Legal */}
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="terms" element={<TermsOfServicePage />} />

            {/* 404 */}
            <Route
              path="*"
              element={
                <div className="container py-12 text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-gray-600 mb-6">페이지를 찾을 수 없습니다.</p>
                  <a
                    href="/"
                    className="inline-block px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors"
                  >
                    홈으로 이동
                  </a>
                </div>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
